"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAutoToc = exports.getAutoTocTitle = exports.AUTO_TOC_NODE_ID = void 0;
var languages_1 = require("./languages");
exports.AUTO_TOC_NODE_ID = '__auto_toc__';
var getAutoTocTitle = function (language) {
    return language === languages_1.LanguageUppercase.FR ? 'Sommaire' : 'Contents';
};
exports.getAutoTocTitle = getAutoTocTitle;
var getPathKey = function (path) { return path.join('/'); };
var buildSheetLabel = function (number, title) { return "".concat(number, ". ").concat(title); };
var buildSheetLeaf = function (sheet) { return ({
    id: sheet.id,
    isPublished: sheet.isPublished,
    label: buildSheetLabel(sheet.number, sheet.title),
    number: sheet.number,
    path: sheet.keyword.path,
    title: sheet.title,
    type: 'sheet',
}); };
var buildNodeEntries = function (node, parentPath, treeData, language, dummyLevel, sheetsByPath) {
    var _a, _b, _c;
    var path = __spreadArray(__spreadArray([], __read(parentPath), false), [node.id], false);
    var items = __spreadArray(__spreadArray([], __read(((_a = sheetsByPath.get(getPathKey(path))) !== null && _a !== void 0 ? _a : []).map(buildSheetLeaf)), false), __read(((_c = (_b = node.children) === null || _b === void 0 ? void 0 : _b.flatMap(function (child) {
        return buildNodeEntries(child, path, treeData, language, dummyLevel, sheetsByPath);
    })) !== null && _c !== void 0 ? _c : [])), false);
    if (!items.length) {
        return [];
    }
    if (!node.title) {
        return items;
    }
    return [
        {
            id: node.id,
            items: items,
            path: path,
            title: node.title,
            type: 'section',
            typography: treeData.getLocalNodeTypography(path, language, dummyLevel),
        },
    ];
};
var buildAutoToc = function (_a) {
    var _b = _a.dummyLevel, dummyLevel = _b === void 0 ? false : _b, _c = _a.includeUnpublished, includeUnpublished = _c === void 0 ? false : _c, language = _a.language, sheets = _a.sheets, treeData = _a.treeData;
    var sheetsByPath = sheets
        .filter(function (_a) {
        var isPublished = _a.isPublished;
        return includeUnpublished || isPublished;
    })
        .sort(function (sheetA, sheetB) { return sheetA.number - sheetB.number; })
        .reduce(function (acc, sheet) {
        var _a;
        var pathKey = getPathKey(sheet.keyword.path);
        var pathSheets = (_a = acc.get(pathKey)) !== null && _a !== void 0 ? _a : [];
        pathSheets.push(sheet);
        acc.set(pathKey, pathSheets);
        return acc;
    }, new Map());
    return treeData.content.flatMap(function (node) {
        return buildNodeEntries(node, [], treeData, language, dummyLevel, sheetsByPath);
    });
};
exports.buildAutoToc = buildAutoToc;
//# sourceMappingURL=autoToc.js.map